import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Wizard, Steps, Step, WithWizard } from "react-albus-react18";
import Home from "./pages/Home";
import { Helmet } from "react-helmet";
import { gsap } from "gsap";
import axios from "axios";
import Do from "./pages/Do/Do";
import Featured from "./pages/Featured/Featured";
import Channels from "./pages/Channels";
import Ai from "./pages/Ai";
import Sell from "./pages/Sell";
import Launch from "./pages/Launch";
import Depends from "./pages/Depends";
import BeforeAfter from "./pages/BeforeAfter";
import Visual from "./pages/Visual";
import Ai2 from "./pages/Ai/Ai";
import Statement from "./pages/Statement";
import Ai3 from "./pages/Ai3";
import Megan from "./pages/Case";
import Choose1 from "./pages/Choose1";
import Choose3 from "./pages/Choose3";
import Choose2 from "./pages/Choose2";
import Choose4 from "./pages/Choose4";
import Knowledge from "./pages/Knowledge";
import BeforeAfter2 from "./pages/BeforeAfter2";
import John from "./pages/John";
import Orders from "./pages/Orders.jsx/Orders";
import Reach from "./pages/Reach";
import Country from "./pages/Country";
import Summary from "./pages/Summary/Summary";
import Reveal from "react-awesome-reveal";
import AnimateHeight from "react-animate-height";
import { keyframes } from "@emotion/react";
import MyButton from "./components/UI/button/MyButton";
import Signup from "./pages/Signup/Signup";
import Name from "./pages/Name";
import Predict from "./pages/Predict";
import Better from "./pages/Better/Better";
import Trial from "./pages/Trial/Trial";
import Bundle from "./pages/Bundle/Bundle";
import Logo from "./components/Logo/Logo";
import Graph from "./pages/Graph/Graph";
import Downgrade from "./pages/Downgrade";
import HaveWebsite from "./pages/HaveWebsite";
import Website from "./pages/Website";
import BusinessArea from "./pages/BusinessArea";
import Orders2 from "./pages/Orders.jsx/Orders2";
import Strategy1 from "./pages/Strategy/Strategy1";
import Strategy2 from "./pages/Strategy/Strategy2";
import Strategy3 from "./pages/Strategy/Strategy3";
import Platform from "./pages/Platform";
import Built1 from "./pages/Built1";
import Term from "./pages/Term";
import Privacy from "./pages/Privacy";
import { useHistory, useLocation } from "react-router-dom";
import WebsiteType from "./pages/WebsiteType";
import Inspiration from "./pages/Inspiration";
import Revenue from "./pages/Revenue";
import Videos from "./pages/Videos";
import Making from "./pages/Making";
import ChooseVideo from "./pages/ChooseVideo";
import Revenue2 from "./pages/Revenue2";
import Goal from "./pages/Goal";
import { Link } from "@mui/material";
import Plan from "./pages/Plan/Plan";
import LogoDark from "./components/Logo/LogoDark";
import WelcomeToZeely from "./pages/WelcomeToZeely/WelcomeToZeely";
import LogoGrowth from "./components/Logo/Logogrowth";
import Signup2 from "./pages/Signup/Signup2";
import CheckEmail from "./components/CheckEmail/CheckEmail";
import Case from "./pages/Case";
import BackHistory from "./components/BackHistory/BackHistory";
import ReactPlayer from "react-player";
import TermPage from "./pages/TermPage";
import PrivacyPage from "./pages/PrivacyPage";
import mixpanel from "mixpanel-browser";
import Home1 from "./pages/Home1/Home1";
import PriceRoute from "./pages/PriceNew/PriceRoute";
import useOverflow from "./hooks/useOverflow";
import useBlockClassName from "./hooks/useBlockClassName";
import Welcome1 from "./pages/Welcome/Welcome1";
import SignupNew from "./pages/SignUpNew/Signup";
import ConfirmEmail from "./pages/ConfirmEmail/ConfirmEmail";
import CompanyName from "./pages/CompanyName/CompanyName";
import CheckDetails from "./pages/CheckDetails/CheckDetails";
import AIAnalyzer from "./pages/AIAnalyzer/AIAnalyzer";
import AIAnalyzerContent from "./pages/AIAnalyzer/AIAnalyzerContent";
import AiAnalyzerImg from "./pages/AIAnalyzer/components/AiAnalyzerImg/AiAnalyzerImg";
import BusinessAreaNew from "./pages/Industry/BusinessArea";
import MyInput from "./components/UI/input/MyInput";
import useFaceBook from "./hooks/useFaceBook";
import VideoToBlob from "./components/VideoToBlob/VideoToBlob";
import SellStage from "./pages/SellStage";
import PreloadImages from "./components/PreloadImages/PreloadImages";
import { useDispatch, useSelector } from "react-redux";
import { setButtonBackClick, setButtonClick } from "./store/buttonSlice";
import InitiateCheckout from "./components/InitiateCheckout/InitiateCheckout";
import Sell2 from "./pages/Sell2";
import Price from "./pages/Price/Price";
import Cookies from "js-cookie";
// import ReactPixel from "react-facebook-pixel";
import Clarity from "@microsoft/clarity";
import useMixpanel from "./hooks/useMixpanel";
import Landing from "./pages/Home1/Landing/Landing";

function App() {
  const { overflow, changeOverflow } = useOverflow();
  const dispatch = useDispatch();
  const { blockClassName } = useBlockClassName();
  const backButton = useSelector((state) => state.button.buttonBackIsShow);

  const { trackEvent } = useMixpanel();

  function setSessionIdLocalStorage(sessionId) {
    localStorage.setItem("session_id", sessionId);
  }

  function getSessionIdFromLocalStorage() {
    return localStorage.getItem("session_id");
  }

  function generateSessionId() {
    return Math.random().toString(36).substring(2);
  }

  const sessionId = getSessionIdFromLocalStorage() || generateSessionId();
  setSessionIdLocalStorage(sessionId);

  useEffect(() => {
    if (window.gtag) return;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=GTM-P42Z2D5R";
    document.head.appendChild(script);

    script.onload = () => {
      window.gtag("js", new Date());
      window.gtag("config", "GTM-P42Z2D5R");
      window.gtag("config", "AW-17610941807");
    };
  }, []);

  useEffect(() => {
    if (window.fbq) return;

    window.fbq = function () {
      window.fbq.callMethod
        ? window.fbq.callMethod.apply(window.fbq, arguments)
        : window.fbq.queue.push(arguments);
    };

    window.fbq.queue = [];
    window.fbq.loaded = true;
    window.fbq.version = "2.0";

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);

    script.onload = () => {
      window.fbq("init", "507395697701950");
    };
  }, []);

  useEffect(() => {
    // const advancedMatching = { em: "support@zeely.app" };
    // const options = {
    //   autoConfig: true,
    //   debug: false,
    // };

    // ReactPixel.init("507395697701950", {}, options);

    mixpanel.init("e777f1e7a8a69795e4b701389d9859a7", {
      ignore_dnt: true,
      debug: true,
      track_pageview: false,
      persistence: "localStorage",
      loaded: function () {
        const anonymousId = mixpanel.get_distinct_id();
        mixpanel.identify(anonymousId);
        mixpanel.people.set({ "Session ID": sessionId });
      },
    });

    const projectId = process.env.REACT_APP_CLARITY_ID;

    if (projectId) {
      Clarity.init(projectId);
      try {
        Clarity.setTag("Session ID", sessionId);
        Clarity.setTag("Funnel", process.env.REACT_APP_FUNNEL);
      } catch (error) {
        console.error(error);
      }
    }

    const isFirstSession = !localStorage.getItem("mixpanel_first_session");

    if (isFirstSession) {
      const userAgent = navigator.userAgent;
      const deviceType = detectDeviceType(userAgent);

      const installationDate = new Date();

      const formattedInstallationDate = formatDate(installationDate);

      localStorage.setItem("installation_date", formattedInstallationDate);
      const urlParams = new URLSearchParams(window.location.search);
      mixpanel.track("SESSION_STARTED", {
        session_id: sessionId,
        // device_type: deviceType,
        session_start: formattedInstallationDate,
        // installation_source: window.location.hostname,
        web_utm_campaign: urlParams.get("utm_campaign"),
        web_utm_source: urlParams.get("utm_source"),
        web_utm_medium: urlParams.get("utm_medium"),
        web_utm_content: urlParams.get("utm_content"),
        web_utm_term: urlParams.get("utm_term"),
        isDebug: false,
        funnel: process.env.REACT_APP_FUNNEL,
      });

      localStorage.setItem("mixpanel_first_session", "true");
    }
  }, []);

  const formatDate = (date) => {
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const seconds = ("0" + date.getSeconds()).slice(-2);

    return `${month}.${day}.${year} ${hours}:${minutes}:${seconds}`;
  };

  const detectDeviceType = (userAgent) => {
    // Example detection logic (you may need to adjust this based on your requirements)
    if (/Android/i.test(userAgent)) {
      return "Android";
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return "iOS";
    } else if (/Windows Phone/i.test(userAgent)) {
      return "Windows Phone";
    } else if (/Windows/i.test(userAgent)) {
      return "Windows";
    } else if (/Macintosh|Mac OS/i.test(userAgent)) {
      return "Macintosh";
    } else if (/Linux/i.test(userAgent)) {
      return "Linux";
    } else {
      return "Unknown";
    }
  };

  const history = useHistory();
  const customAnimation = keyframes`
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  `;
  const [buttonText, setButtonText] = useState("Continue");
  const [buttonShow, setButtonShow] = useState(false);
  const [buttonTime, setButtonTime] = useState(0);
  const [buttonChoose, setButtonChoose] = useState(false);
  const [creativeId, setCreativeId] = useState("");
  const [creativeType, setCreativeType] = useState("");
  const [buttonStatus, setButtonStatus] = useState("");
  const [loginChangeStatus, setLoginChangeStatus] = useState(false);
  const [buttonSkip, setButtonSkip] = useState(false);
  const nextPageButtonRef = useRef(null);
  const [aiShow, setAiShow] = useState(false);
  const [homeShow, sethomeShow] = useState(false);
  const [handShow, setHandShow] = useState(false);
  const [blockStyle, setBlockStyle] = useState({});
  const [welcometoShow, setWelcometo] = useState(false);
  const [WelcomeWrapper, setWelcomeWrapper] = useState(false);
  const [showBrandName, setShowBrandName] = useState(false);
  const [showWebSite, setShowWebSite] = useState(false);

  const [timeLeft, setTimeLeft] = useState(30);
  const [isChecked, setIsChecked] = useState(true);
  const [showTerm, setShowTerm] = useState(false);
  const [showTermBundle, setShowTermBundle] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showBlock, setShowBlock] = useState(true);
  const [signupBottom, setSignupBottom] = useState("");
  const [priceBottomShow, setPriceBottomShow] = useState(false);

  const [muteStatus, setMuteStatus] = useState(true);

  const [blockHeight, setBlockHeight] = useState("auto");
  const [blockPaddingBottom, setBlockPaddingBottom] = useState("32rem");
  const [whiteWrapper, setWhiteWrapper] = useState(false);
  const blockHeightRef = useRef(null);

  const [isHomePage, setIsHomePage] = useState(true);

  const updateHeight = () => {
    if (blockHeightRef.current) {
      const newHeight = blockHeightRef.current.offsetHeight;
      setBlockHeight(newHeight);
    }
  };

  useEffect(() => {
    updateHeight();
    const observer = new MutationObserver(updateHeight);
    if (blockHeightRef.current) {
      observer.observe(blockHeightRef.current, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }

    return () => {
      observer.disconnect();
    };
  }, [blockHeightRef, isHomePage]);

  const [checkboxes, setCheckboxes] = useState({
    Facebook: true,
  });
  const [error, setError] = useState(false);
  const [selectedOption, setSelectedOption] = useState("1");

  const areAllCheckboxesUnchecked = () => {
    return Object.values(checkboxes).every((isChecked) => !isChecked);
  };

  const areAllRadioUnchecked = () => {
    return selectedOption === null;
  };

  const [caseStatus, setCaseStatus] = useState(true);
  const [caseName, setCaseName] = useState("case1");

  useEffect(() => {
    if (localStorage.getItem("direction")) {
      if (localStorage.getItem("direction") === "SERVICE") {
        setCaseStatus(false);
        setCaseName("case2");
      } else {
        setCaseStatus(true);
        setCaseName("case1");
      }
    }
  }, [localStorage.getItem("direction")]);

  const forgetPassword = (email) => {
    const data = {
      email: email,
    };

    axios
      .post("https://staging.zeely.link/users/forgot-password", data, {
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
      })
      .then((response) => {})
      .catch((error) => {});
  };

  const [eventProperties, setEventProperties] = useState([]);
  const [eventName, setEventName] = useState([]);

  const queryParams = new URLSearchParams(window.location.search);

  const HomeElement = (
    <Home
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonText={setButtonText}
      setButtonShow={setButtonShow}
      setButtonTime={setButtonTime}
    />
  );

  const DoElement = (
    <Do
      error={error}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      setBlockPaddingBottom={setBlockPaddingBottom}
      sethomeShow={sethomeShow}
      setButtonStatus={setButtonStatus}
      sessionId={sessionId}
      setButtonShow={setButtonShow}
      setButtonTime={setButtonTime}
      buttonStatus={buttonStatus}
      setSelectedOption={setSelectedOption}
    />
  );
  const FeaturedElement = (
    <Featured
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setSelectedOption={setSelectedOption}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setCheckboxes={setCheckboxes}
      setBlockPaddingBottom={setBlockPaddingBottom}
    />
  );
  const GoalElement = (
    <Goal
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setCheckboxes={setCheckboxes}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setButtonStatus={setButtonStatus}
      setAiShow={setAiShow}
      setButtonText={setButtonText}
      setError={setError}
      error={error}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      setButtonShow={setButtonShow}
      setButtonTime={setButtonTime}
    />
  );
  const ChannelsElement = (
    <Channels
      setButtonSkip={setButtonSkip}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      buttonStatus={buttonStatus}
      setButtonStatus={setButtonStatus}
      setCheckboxes={setCheckboxes}
      checkboxes={checkboxes}
      setSelectedOption={setSelectedOption}
      selectedOption={selectedOption}
      setError={setError}
      error={error}
      setButtonText={setButtonText}
      setButtonShow={setButtonShow}
    />
  );
  const AiElement = (
    <Ai setButtonText={setButtonText} setSelectedOption={setSelectedOption} />
  );
  const SellElement = (
    <Sell
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      buttonStatus={buttonStatus}
      setButtonStatus={setButtonStatus}
      setButtonText={setButtonText}
      setError={setError}
      error={error}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      setButtonShow={setButtonShow}
      setButtonTime={setButtonTime}
    />
  );
  const [WebsiteStatus, setWebsiteStatus] = useState(false);
  const HaveWebsiteElement = (
    <HaveWebsite
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonShow={setButtonShow}
      setButtonTime={setButtonTime}
      setSelectedOption={setSelectedOption}
      setButtonText={setButtonText}
      setWebsiteStatus={setWebsiteStatus}
    />
  );
  const PlatformElement = (
    <Platform
      setButtonSkip={setButtonSkip}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setButtonStatus={setButtonStatus}
      setAiShow={setAiShow}
      setButtonText={setButtonText}
      setError={setError}
      error={error}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      setButtonShow={setButtonShow}
      setButtonTime={setButtonTime}
    />
  );
  const WebsiteTypeElement = (
    <WebsiteType
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setButtonStatus={setButtonStatus}
      setAiShow={setAiShow}
      setButtonText={setButtonText}
      setError={setError}
      error={error}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      setButtonShow={setButtonShow}
      setButtonTime={setButtonTime}
    />
  );

  useEffect(() => {
    if (localStorage.getItem("haveWebsite")) {
      if (localStorage.getItem("haveWebsite") == "No") {
        setWebsiteStatus(false);
      }
      if (localStorage.getItem("haveWebsite") == "Yes") {
        setWebsiteStatus(true);
      }
    }
  }, []);

  const handleClickAi = () => {
    if (nextPageButtonRef.current) {
      // nextPageButtonRef.current.click();
    }
  };

  const Ai2Element = (
    <Ai2
      videoShowStatus={true}
      timingInterval={[30, 30, 40]}
      videoSrc="shopify_shop_flow_mockup_compressed.m3u8"
      videoImg="Shopify shop flow mockup cover_compressed.webp"
      nextPage="/haveyouever_2"
      handleClickAi={handleClickAi}
      aiText={
        [
          ["See how easy it is to set", " up\u00A0your account on Zeely"],
          ["Just connect your store in", "a few clicks"],
          ["And select products or", "services to promote"],
        ]
        // WebsiteStatus
        //   ?
        //   : [
        //       ["See how easy it is to make", "a site with AI on Zeely"],
        //       ["AI assists you in adding", "your products or services"],
        //       ["And setting up payments", "to earn from sales"],
        //     ]
      }
      eventName={"web_demosite"}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setButtonStatus={setButtonStatus}
      setAiShow={setAiShow}
      setButtonText={setButtonText}
      setSelectedOption={setSelectedOption}
      setButtonShow={setButtonShow}
    />
  );
  const Ai2NoElement = (
    <Ai2
      videoShowStatus={true}
      timingInterval={[70, 50, 40]}
      videoSrc="show_flow_mockup_compressed.m3u8"
      videoImg="shop flow mockup cover_compressed.webp"
      nextPage="/haveyouever_2"
      handleClickAi={handleClickAi}
      aiText={
        WebsiteStatus
          ? [
              ["See how easy it is to set", " up\u00A0your account on Zeely"],
              ["Just connect your store in", "a few clicks"],
              ["And select products or", "services to promote"],
            ]
          : [
              ["See how easy it is to make", "a site with AI on Zeely"],
              ["AI assists you in adding", "your products or services"],
              ["And setting up payments", "to earn from sales"],
            ]
      }
      eventName={"web_demosite"}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setButtonStatus={setButtonStatus}
      setAiShow={setAiShow}
      setButtonText={setButtonText}
      setSelectedOption={setSelectedOption}
      setButtonShow={setButtonShow}
    />
  );

  const LaunchElement = (
    <Launch
      error={error}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setButtonStatus={setButtonStatus}
      setAiShow={setAiShow}
      setButtonShow={setButtonShow}
      setButtonTime={setButtonTime}
      setSelectedOption={setSelectedOption}
    />
  );
  const DependsElement = (
    <Depends
      error={error}
      setSelectedOption={setSelectedOption}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonShow={setButtonShow}
    />
  );
  const BeforeafterElement = (
    <BeforeAfter
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setCheckboxes={setCheckboxes}
      setSelectedOption={setSelectedOption}
    />
  );
  const Built1Element = (
    <Built1
      setAiShow={setAiShow}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setButtonStatus={setButtonStatus}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setCheckboxes={setCheckboxes}
      setButtonText={setButtonText}
      setError={setError}
      error={error}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      setButtonShow={setButtonShow}
    />
  );
  const VisualElement = (
    <Visual
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setSelectedOption={setSelectedOption}
      setButtonStatus={setButtonStatus}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setAiShow={setAiShow}
      setCheckboxes={setCheckboxes}
      checkboxes={checkboxes}
      setError={setError}
      error={error}
      setButtonText={setButtonText}
      setButtonShow={setButtonShow}
    />
  );
  const StatementElement = (
    <Statement
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonStatus={setButtonStatus}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setAiShow={setAiShow}
      setButtonText={setButtonText}
      setError={setError}
      error={error}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      setButtonShow={setButtonShow}
    />
  );
  const InspirationElement = (
    <Inspiration
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonChoose={setButtonChoose}
      setCheckboxes={setCheckboxes}
      setButtonText={setButtonText}
      setError={setError}
      error={error}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      setButtonShow={setButtonShow}
    />
  );
  const Choose1Element = (
    <Choose1
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setCreativeType={setCreativeType}
      setCreativeId={setCreativeId}
      setSelectedOption={setSelectedOption}
      setButtonShow={setButtonShow}
      setButtonChoose={setButtonChoose}
      setButtonTime={setButtonTime}
    />
  );
  const Choose2Element = (
    <Choose2
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setCreativeType={setCreativeType}
      setCreativeId={setCreativeId}
      setButtonShow={setButtonShow}
      setButtonChoose={setButtonChoose}
    />
  );
  const Choose3Element = (
    <Choose3
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setCreativeType={setCreativeType}
      setCreativeId={setCreativeId}
      setButtonShow={setButtonShow}
      setButtonChoose={setButtonChoose}
      setButtonStatus={setButtonStatus}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setAiShow={setAiShow}
    />
  );
  const Choose4Element = (
    <Choose4
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setCreativeType={setCreativeType}
      setCreativeId={setCreativeId}
      setButtonShow={setButtonShow}
      setButtonChoose={setButtonChoose}
      setButtonStatus={setButtonStatus}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setAiShow={setAiShow}
    />
  );
  const Ai3Element = (
    <Ai3 setButtonShow={setButtonShow} setButtonText={setButtonText} />
  );
  const MeganElement = (
    <Megan
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setButtonChoose={setButtonChoose}
      setButtonTime={setButtonTime}
    />
  );

  const RevenueElement = (
    <Revenue
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonStatus={setButtonStatus}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setAiShow={setAiShow}
      setButtonTime={setButtonTime}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setButtonChoose={setButtonChoose}
      setSelectedOption={setSelectedOption}
    />
  );

  const Strategy1Element = (
    <Strategy1
      setButtonChoose={setButtonChoose}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
    />
  );
  const Strategy2Element = (
    <Strategy2 setButtonShow={setButtonShow} setButtonText={setButtonText} />
  );
  const Strategy3Element = (
    <Strategy3
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setSelectedOption={setSelectedOption}
    />
  );

  const VideosElement = (
    <Videos
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setCheckboxes={setCheckboxes}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
    />
  );
  const MakingElement = (
    <Making
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setSelectedOption={setSelectedOption}
      setButtonStatus={setButtonStatus}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setAiShow={setAiShow}
      setCheckboxes={setCheckboxes}
      checkboxes={checkboxes}
      setError={setError}
      error={error}
      setButtonText={setButtonText}
      setButtonShow={setButtonShow}
    />
  );
  const KnowledgeElement = (
    <Knowledge
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setButtonStatus={setButtonStatus}
      setAiShow={setAiShow}
      setButtonText={setButtonText}
      setError={setError}
      error={error}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      setButtonShow={setButtonShow}
      setButtonChoose={setButtonChoose}
    />
  );
  const ChooseVideo1Element = (
    <ChooseVideo
      eventName={"web_example_1"}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      creativeId={"creativeId5"}
      setCreativeId={setCreativeId}
      setCreativeType={setCreativeType}
      muteStatus={muteStatus}
      setMuteStatus={setMuteStatus}
      videoCV="Customer_review.mp4"
      imgCV="Customer_review.webp"
      textCV1="Customer review"
      textCV2="Source: Foreplay"
      setButtonTime={setButtonTime}
      setButtonChoose={setButtonChoose}
      setButtonShow={setButtonShow}
    />
  );
  const ChooseVideo2Element = (
    <ChooseVideo
      eventName={"web_example_2"}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      creativeId={"creativeId6"}
      setCreativeId={setCreativeId}
      setCreativeType={setCreativeType}
      muteStatus={muteStatus}
      setMuteStatus={setMuteStatus}
      videoCV="Product_demo.mp4"
      imgCV="Product_demo.webp"
      textCV1="Product & service demo"
      textCV2="Source: Visp"
      setButtonShow={setButtonShow}
      setButtonChoose={setButtonChoose}
    />
  );
  const ChooseVideo3Element = (
    <ChooseVideo
      eventName={"web_example_3"}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      creativeId={"creativeId7"}
      setCreativeId={setCreativeId}
      setCreativeType={setCreativeType}
      muteStatus={muteStatus}
      setMuteStatus={setMuteStatus}
      videoCV="Unpacking.mp4"
      imgCV="Unpacking.webp"
      textCV1="Product unboxing"
      textCV2="Source: Truly Grounded"
      setButtonShow={setButtonShow}
      setButtonChoose={setButtonChoose}
    />
  );
  const ChooseVideo4Element = (
    <ChooseVideo
      eventName={"web_example_4"}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      creativeId={"creativeId8"}
      setCreativeId={setCreativeId}
      setCreativeType={setCreativeType}
      muteStatus={muteStatus}
      setMuteStatus={setMuteStatus}
      videoCV="Lifestyle.mp4"
      imgCV="Lifestyle.webp"
      textCV1="Lifestyle"
      textCV2="Source: Ryze"
      setButtonShow={setButtonShow}
      setButtonChoose={setButtonChoose}
      setButtonStatus={setButtonStatus}
      setAiShow={setAiShow}
      setBlockPaddingBottom={setBlockPaddingBottom}
    />
  );
  const Revenue2Element = (
    <Revenue2
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setButtonStatus={setButtonStatus}
      setAiShow={setAiShow}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setButtonChoose={setButtonChoose}
      setSelectedOption={setSelectedOption}
      setButtonTime={setButtonTime}
    />
  );

  const Beforeafter2Element = (
    <BeforeAfter2
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonTime={setButtonTime}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
    />
  );

  const OrdersElement = (
    <Orders
      setAiShow={setAiShow}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setButtonStatus={setButtonStatus}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      buttonStatus={buttonStatus}
    />
  );
  const Orders2Element = (
    <Orders2
      setSelectedOption={setSelectedOption}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      buttonStatus={buttonStatus}
      setButtonStatus={setButtonStatus}
      setButtonTime={setButtonTime}
    />
  );
  const ReachElement = (
    <Reach
      error={error}
      setButtonText={setButtonText}
      setSelectedOption={setSelectedOption}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonShow={setButtonShow}
      buttonStatus={buttonStatus}
      setButtonStatus={setButtonStatus}
      setButtonTime={setButtonTime}
    />
  );
  const CountryElement = (
    <Country
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      buttonStatus={buttonStatus}
      setButtonStatus={setButtonStatus}
    />
  );
  const SummaryElement = (
    <Summary
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setButtonStatus={setButtonStatus}
    />
  );
  const termChange = () => {
    setShowBlock(false);
    setButtonShow(false);
    setShowTerm(true);
    setBlockPaddingBottom("0");
  };

  const privacyChange = () => {
    setShowBlock(false);
    setButtonShow(false);
    setShowPrivacy(true);
    setBlockPaddingBottom("0");
  };
  const [pageComponent, setPageComponent] = useState("checkEmail");

  const stepSignupPage = [
    ["checkEmail"],
    [
      "loginToEmail",
      "loginEmail",
      "confirmForgetEmail",
      "enterCode",
    ],
    ["signupEmail", "newPassword", "signinSuccess"],
  ];

  const indexStepPage = stepSignupPage.findIndex((group) =>
    group.includes(pageComponent),
  );

  const SignupElement = (
    <Signup
      pageComponent={pageComponent}
      setPageComponent={setPageComponent}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setTimeLeft={setTimeLeft}
      forgetPassword={forgetPassword}
      setLoginChangeStatus={setLoginChangeStatus}
      setSelectedOption={setSelectedOption}
      setError={setError}
      error={error}
      buttonStatus={buttonStatus}
      setButtonStatus={setButtonStatus}
      setBlockPaddingBottom={setBlockPaddingBottom}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      signupBottom={signupBottom}
      setSignupBottom={setSignupBottom}
      privacyChange={privacyChange}
      termChange={termChange}
    />
  );
  const NameElement = (
    <Name
      error={error}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setButtonStatus={setButtonStatus}
      setSignupBottom={setSignupBottom}
      setSelectedOption={setSelectedOption}
      setError={setError}
    />
  );

  const SignupElement2 = (
    <Signup2
      forgetPassword={forgetPassword}
      setWelcomeWrapper={setWelcomeWrapper}
      setBlockPaddingBottom={setBlockPaddingBottom}
      sessionId={sessionId}
      setShowBrandName={setShowBrandName}
      setShowWebSite={setShowWebSite}
      setWelcometo={setWelcometo}
      setWhiteWrapper={setWhiteWrapper}
      setLoginChangeStatus={setLoginChangeStatus}
      setSelectedOption={setSelectedOption}
      setError={setError}
      error={error}
      buttonStatus={buttonStatus}
      setButtonStatus={setButtonStatus}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      signupBottom={signupBottom}
      setSignupBottom={setSignupBottom}
    />
  );

  const Case1Element = (
    <Case
      setSelectedOption={setSelectedOption}
      setButtonSkip={setButtonSkip}
      title={
        localStorage.getItem("direction") === "SERVICE"
          ? "“I've got 500+ new clients”"
          : "“I got 400+ new orders”"
      }
      name={"Scarlette Goff"}
      date={"4 weeks ago"}
      text={
        localStorage.getItem("direction") === "SERVICE"
          ? "I’m flooded with new clients for my beauty services — never thought growth could be this quick, all thanks to Zeely. The viral AI videos are smashing it. "
          : "I’m flooded with orders — never thought growth could be this quick, all thanks to Zeely. The viral AI videos are smashing it. "
      }
      img={"case1.png"}
      stat={
        localStorage.getItem("direction") === "SERVICE"
          ? "case2-stat.webp"
          : "case1-stat.webp"
      }
      eventName={"web_usecase_1"}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setButtonChoose={setButtonChoose}
      setButtonTime={setButtonTime}
    />
  );

  const Case2Element = (
    <Case
      setSelectedOption={setSelectedOption}
      setButtonSkip={setButtonSkip}
      title={"“I've got 500+ new clients”"}
      name={"Scarlette Goff"}
      date={"4 weeks ago"}
      text={
        "I’m flooded with new clients for my beauty services — never thought growth could be this quick, all thanks to Zeely. The viral AI videos are smashing it.  "
      }
      img={"case1.png"}
      stat={"case2-stat.webp"}
      eventName={"web_usecase_1"}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setButtonChoose={setButtonChoose}
      setButtonTime={setButtonTime}
    />
  );
  const Case3Element = (
    <Case
      setSelectedOption={setSelectedOption}
      setButtonSkip={setButtonSkip}
      title={
        localStorage.getItem("direction") === "SERVICE"
          ? "“Less effort, 3x clients!”"
          : "“Less effort, 3x orders!”"
      }
      name={"Scarlette Goff"}
      date={"4 weeks ago"}
      text={
        localStorage.getItem("direction") === "SERVICE"
          ? "Before, I was struggle with sales and wasn't getting new customers. After a month with Zeely AI, I got 3x orders from 4 posts that went viral. Now I'm fully booked!!"
          : "Before, I was struggle with sales and wasn't getting new customers. After a month with Zeely AI, I got 3x orders from 4 posts that went viral. Now I'm fully booked!!"
      }
      img={"case4.png"}
      stat={"case3-stat.webp"}
      eventName={"web_usecase_2"}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setButtonChoose={setButtonChoose}
      setButtonTime={setButtonTime}
    />
  );
  const Case4Element = (
    <Case
      setSelectedOption={setSelectedOption}
      title={
        localStorage.getItem("acquisition") === "both"
          ? "“Same spend, 2x orders”"
          : localStorage.getItem("acquisition") === "2"
            ? "“Less effort, 8x followers ”"
            : "“Same spend, 2x orders”"
      }
      name={"Ellis Spencer"}
      date={"1 month ago"}
      text={
        localStorage.getItem("acquisition") === "both"
          ? "Before, my ad spend was getting decent results — about 30 sales. Once I plugged in Zeely's AI videos, I saw the difference instantly. Same budget, double the return."
          : localStorage.getItem("acquisition") === "2"
            ? "Before,  I was stuck at 1300 followers and wasn’t getting new customers. After a month with Zeely AI, I got 9k new followers from 4 videos that went viral. I’m fully booked with clients now!!"
            : "Before, my ad spend was getting decent results — about 30 sales. Once I plugged in Zeely's AI videos, I saw the difference instantly. Same budget, double the return."
      }
      img={"case4.png"}
      stat={
        localStorage.getItem("acquisition") === "both"
          ? "case4-stat-1.webp"
          : localStorage.getItem("acquisition") === "2"
            ? "case4-stat.webp"
            : "case4-stat-1.webp"
      }
      eventName={"web_usecase_3"}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setButtonChoose={setButtonChoose}
      setButtonTime={setButtonTime}
    />
  );
  const Case5Element = (
    <Case
      title={"“Overperformed my goal”"}
      name={"Mark V. Powell"}
      date={"4 weeks ago"}
      text={
        localStorage.getItem("direction") === "SERVICE"
          ? "Got into Zeely with a goal that seemed way out there. Just stuck with it, rolled with the plan, played around with the AI videos, and..."
          : "Got into Zeely with a goal that seemed way out there. Just stuck with it, rolled with the plan,  played around with the AI tools, and bam! I overperformed my goal."
      }
      img={"case5.png"}
      stat={"case5-stat-1.webp"}
      eventName={"web_usecase_3"}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setButtonChoose={setButtonChoose}
      setButtonTime={setButtonTime}
    />
  );

  const PriceElement = (
    <PriceRoute
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setShowTermBundle={setShowTermBundle}
      setPriceBottomShow={setPriceBottomShow}
      setButtonShow={setButtonShow}
      setButtonText={setButtonText}
      setWhiteWrapper={setWhiteWrapper}
    />
  );
  const [trialLoad, setTrialLoad] = useState();

  const [time, setTime] = useState(() => {
    const savedTime = localStorage.getItem("timerTime");
    return savedTime ? parseInt(savedTime, 10) : 600;
  });
  const [showPromo, setShowPromo] = useState(true);

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "timerTime" && e.newValue) {
        setTime(parseInt(e.newValue, 10));
      } else if (e.key === "timerTime" && e.newValue === null) {
        setTime(600);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
  const TrialElement = (
    <Trial
      setBlockStyle={setBlockStyle}
      setEventName={setEventName}
      setEventProperties={setEventProperties}
      sessionId={sessionId}
      setTrialLoad={setTrialLoad}
      setShowTermBundle={setShowTermBundle}
      setButtonShow={setButtonShow}
      setWelcometo={setWelcometo}
      setWhiteWrapper={setWhiteWrapper}
      time={time}
      setTime={setTime}
    />
  );

  const stepsMain = [
    // {
    //   id: "",
    //   component: (
    //     // <Start
    //     //   setButtonShow={setButtonShow}
    //     //   setHandShow={setHandShow}
    //     //   setBlockPaddingBottom={setBlockPaddingBottom}
    //     //   sethomeShow={sethomeShow}
    //     //   setButtonStatus={setButtonStatus}
    //     // />
    //     <Page2
    //       sessionId={sessionId}
    //       setButtonShow={setButtonShow}
    //       setHandShow={setHandShow}
    //       setBlockPaddingBottom={setBlockPaddingBottom}
    //       sethomeShow={sethomeShow}
    //       setButtonStatus={setButtonStatus}
    //     />
    //   ),
    //   preload: (
    //     <PreloadImages images={['sell1.webp', 'sell2.webp','sell3.webp','sell4.webp','sell5.webp',]}/>

    //   ),
    // },
    // { id: '', component: HomeElement, preload: DoElement },
    // {
    //   id: "sellingstage",
    //   component: (
    //     <SellStage
    //       setEventName={setEventName}
    //       setEventProperties={setEventProperties}
    //       sessionId={sessionId}
    //       buttonStatus={buttonStatus}
    //       setButtonStatus={setButtonStatus}
    //       setButtonText={setButtonText}
    //       setError={setError}
    //       error={error}
    //       selectedOption={selectedOption}
    //       setSelectedOption={setSelectedOption}
    //       setButtonShow={setButtonShow}
    //       setButtonTime={setButtonTime}
    //       setBlockPaddingBottom={setBlockPaddingBottom}
    //       sethomeShow={sethomeShow}
    //     />
    //   ),
    //   preload: (
    //     <PreloadImages images={["goal1.webp", "goal2.webp", "goal3.webp"]} />
    //   ),
    // },
    // {
    //   id: "goals",
    //   component: (
    //     <Sell2
    //       setEventName={setEventName}
    //       setEventProperties={setEventProperties}
    //       sessionId={sessionId}
    //       buttonStatus={buttonStatus}
    //       setButtonStatus={setButtonStatus}
    //       setButtonText={setButtonText}
    //       setError={setError}
    //       error={error}
    //       selectedOption={selectedOption}
    //       setSelectedOption={setSelectedOption}
    //       setButtonShow={setButtonShow}
    //       setButtonTime={setButtonTime}
    //     />
    //   ),
    //   preload: (
    //     <BusinessArea
    //       preload={true}
    //       setEventName={setEventName}
    //       setEventProperties={setEventProperties}
    //       sessionId={sessionId}
    //       error={error}
    //       setSelectedOption={setSelectedOption}
    //       setButtonShow={setButtonShow}
    //       setBlockPaddingBottom={setBlockPaddingBottom}
    //       setButtonStatus={setButtonStatus}
    //       setAiShow={setAiShow}
    //     />
    //   ),
    // },
    // {
    //   id: "industry",
    //   component: (
    //     <BusinessArea
    //       setButtonSkip={setButtonSkip}
    //       setEventName={setEventName}
    //       setEventProperties={setEventProperties}
    //       sessionId={sessionId}
    //       error={error}
    //       setSelectedOption={setSelectedOption}
    //       setButtonShow={setButtonShow}
    //       setBlockPaddingBottom={setBlockPaddingBottom}
    //       setButtonStatus={setButtonStatus}
    //       setAiShow={setAiShow}
    //     />
    //   ),
    //   preload: (
    //     <PreloadImages
    //       images={[
    //         "Shopify.svg",
    //         "AD-chanel.svg",
    //         "TikTok.webp",
    //         "Amazon.svg",
    //         "domain.svg",
    //         "WordPress.svg",
    //         "Wix.svg",
    //         "Etsy.svg",
    //         "Other.svg",
    //       ]}
    //     />
    //   ),
    // },

    { id: "signup", component: SignupElement, preload: "" },
    {
      id: "name",
      component: NameElement,
      preload: <PreloadImages images={["Predict.webp"]} />,
    },
    {
      id: "loader",
      component: (
        <WelcomeToZeely
          setButtonShow={setButtonShow}
          setEventName={setEventName}
          setEventProperties={setEventProperties}
          sessionId={sessionId}
          setWelcometo={setWelcometo}
          setWhiteWrapper={setWhiteWrapper}
        />
      ),
      preload: "",
    },

    {
      id: "thankyou",
      component: (
        <Welcome1
          setEventName={setEventName}
          setEventProperties={setEventProperties}
          sessionId={sessionId}
          setButtonShow={setButtonShow}
          setButtonStatus={setButtonStatus}
          setShowBrandName={setShowBrandName}
          BrandName={false}
          setShowWebSite={setShowWebSite}
          WebSite={false}
          setWelcomeWrapper={setWelcomeWrapper}
          setBlockPaddingBottom={setBlockPaddingBottom}
          setWhiteWrapper={setWhiteWrapper}
        />
      ),
      preload: <John />,
    },
    { id: "signup2", component: SignupElement2, preload: "" },
    {
      id: "term",
      component: (
        <TermPage
          setWhiteWrapper={setWhiteWrapper}
          setShowBlock={setShowBlock}
          setButtonShow={setButtonShow}
          setShowTerm={setShowTerm}
        />
      ),
      preload: "",
    },
    {
      id: "privacy",
      component: (
        <PrivacyPage
          setWhiteWrapper={setWhiteWrapper}
          setShowBlock={setShowBlock}
          setButtonShow={setButtonShow}
          setShowPrivacy={setShowPrivacy}
        />
      ),
      preload: "",
    },
  ];

  const [BusinessAreaHave, setBusinessAreaHave] = useState(1);

  function formatDuration(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return {
      hours,
      minutes,
      seconds: remainingSeconds,
    };
  }

  const handleChange = () => {
    setIsChecked(!isChecked);
  };

  const termClose = () => {
    setShowBlock(true);
    setShowTerm(false);
    setShowPrivacy(false);
    setBlockPaddingBottom("32rem");
  };

  const termBundleClose = () => {
    setShowTermBundle(false);
  };

  const loginChange = () => {
    setButtonStatus("loginChange");
  };

  const handleClickChoose = (nextFunction, clickedElement, id, value) => {
    var profilesJSON = localStorage.getItem("business-profiles");
    if (profilesJSON) {
      var profiles = JSON.parse(profilesJSON);
      profiles.forEach(function (profile) {
        profile.creativesQuiz = profile.creativesQuiz || {};
        if (profile.creativesQuiz.hasOwnProperty(id)) {
          profile.creativesQuiz[id] = { type: creativeType, checked: value };
        } else {
          profile.creativesQuiz[id] = { type: creativeType, checked: value };
        }
      });
      var updatedProfilesJSON = JSON.stringify(profiles);
      localStorage.setItem("business-profiles", updatedProfilesJSON);
    } else {
      var newProfile = {
        creativesQuiz: {},
      };
      newProfile.creativesQuiz[id] = { type: creativeType, checked: value };
      var newProfiles = [newProfile];
      var newProfilesJSON = JSON.stringify(newProfiles);
      localStorage.setItem("business-profiles", newProfilesJSON);
    }

    const tl = gsap.timeline();
    tl.to(clickedElement, {
      duration: 0.085,
      scale: 0.95,
      opacity: 0.85,
      background: "#F2F4F6",
      ease: "power4.out",
    });
    tl.to(clickedElement, {
      duration: 0.55,
      scale: 1,
      opacity: 1,
      background: "#FFF",
      ease: "elastic.out(1,0.6)",
    });
    const urlParams = new URLSearchParams(window.location.search);
    const preEventProperties = eventProperties;

    preEventProperties.web_utm_campaign = urlParams.get("utm_campaign");
    preEventProperties.web_utm_source = urlParams.get("utm_source");
    preEventProperties.web_utm_medium = urlParams.get("utm_medium");
    preEventProperties.web_utm_content = urlParams.get("utm_content");
    preEventProperties.web_utm_term = urlParams.get("utm_term");
    preEventProperties.isDebug = false;
    preEventProperties.funnel = process.env.REACT_APP_FUNNEL;
    mixpanel.track(eventName, eventProperties);

    setTimeout(() => {
      nextFunction();
    }, 350);
  };

  const [businessProfilesUpdated, setBusinessProfilesUpdated] = useState(false);

  const [trialNext, setTrialNext] = useState();
  const [trialStatus, setTrialStatus] = useState(false);

  useEffect(() => {
    if (trialStatus) {
      if (trialLoad) {
        setButtonStatus("load");
      } else {
        // if (typeof trialNext === "function") {
        setTimeout(() => {
          setButtonStatus("");
          setTrialStatus(false);
          const urlParams = new URLSearchParams(window.location.search);

          const preEventProperties = eventProperties;

          preEventProperties.web_utm_campaign = urlParams.get("utm_campaign");
          preEventProperties.web_utm_source = urlParams.get("utm_source");
          preEventProperties.web_utm_medium = urlParams.get("utm_medium");
          preEventProperties.web_utm_content = urlParams.get("utm_content");
          preEventProperties.web_utm_term = urlParams.get("utm_term");
          preEventProperties.isDebug = false;
          preEventProperties.funnel = process.env.REACT_APP_FUNNEL;

          if (eventName === "web_price") {
            preEventProperties.plan_name = localStorage.getItem("plan");
          }
          mixpanel.track(eventName, eventProperties);
          debugger;
          dispatch(setButtonClick(true));
        }, 300);
        //
      }
    }
  }, [trialLoad, trialStatus]);

  const handleClickSkip = () => {
    dispatch(setButtonClick(true));
  };

  const previousPage = useSelector((state) => state.appRoute.previousPage);

  const handleClick = (next) => {
    if (buttonStatus == "checkEmail") {
      // setError(true);
      setButtonStatus("checkEmailLoad");
      return;
    }

    if (trialLoad === true) {
      setTrialStatus(true);
      // setTrialNext(() => next);
      return;
    }

    if (buttonStatus == "load") {
      return;
    }
    if (buttonStatus == "signIn") {
      setButtonStatus("signInLoad");
      return;
    }
    if (buttonStatus == "signUp") {
      setButtonStatus("signUpLoad");
      return;
    }

    if (buttonStatus == "EnterEmail") {
      setButtonStatus("EnterEmailLoad");
      return;
    }
    if (buttonStatus == "EnterCode") {
      setButtonStatus("EnterCodeLoad");
      return;
    }

    if (buttonStatus == "NewPassword") {
      setButtonStatus("NewPasswordLoad");
      return;
    }

    if (buttonStatus === "businessProfilesUpdate") {
      const webEntrance =
        localStorage.getItem("signupMethod") === "Login" ? "login" : "signup";

      dispatch(setButtonClick(true));
      businessProfilesUpdate();
      NameUpdate();
      setError(false);
      return;
    }

    if (buttonStatus == "Summary") {
      setButtonStatus("SummaryLoad");
      return;
    }

    if (areAllCheckboxesUnchecked() || areAllRadioUnchecked()) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 1000);
    } else {
      setError(false);
      const preEventProperties = eventProperties;
      const urlParams = new URLSearchParams(window.location.search);
      preEventProperties.web_utm_campaign = urlParams.get("utm_campaign");
      preEventProperties.web_utm_source = urlParams.get("utm_source");
      preEventProperties.web_utm_medium = urlParams.get("utm_medium");
      preEventProperties.web_utm_content = urlParams.get("utm_content");
      preEventProperties.web_utm_term = urlParams.get("utm_term");
      preEventProperties.isDebug = false;
      preEventProperties.funnel = process.env.REACT_APP_FUNNEL;

      if (eventName === "web_price") {
        preEventProperties.plan_name = localStorage.getItem("plan");
      }
      dispatch(setButtonClick(true));

      if (eventName === "web_start") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "form_start",
        });
      }
      if (eventName === "web_demosite") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "quiz_funnel1",
        });
      }
      if (eventName === "web_democreatives") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "quiz_funnel2",
        });
      }
      if (eventName === "web_demovideos") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "quiz_funnel3",
        });
      }
      if (eventName === "web_loading") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "quiz_funnel4",
        });
      }

      // next();
    }
  };

  const businessProfilesUpdate = () => {
    const fullJSON = localStorage.getItem("business-profiles");
    const profile = JSON.parse(fullJSON)[0];
    const trimmedJSON = JSON.stringify(profile);

    const data = trimmedJSON;
    if (localStorage.getItem("signupMethod") === "Login") {
      axios
        .get("https://staging.zeely.link/business-profiles", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          redirect: "follow",
        })

        .then((response) => {
          axios
            .patch(
              `https://staging.zeely.link/business-profiles/${response.data.data.id}`,
              data,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken",
                  )}`,
                },
                redirect: "follow",
              },
            )
            .then((response) => {
              localStorage.setItem(
                "business-profiles-id",
                response.data.data.id,
              );
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .post("https://staging.zeely.link/business-profiles", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          redirect: "follow",
        })
        .then((response) => {
          localStorage.setItem("business-profiles-id", response.data.data.id);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const { sendFb } = useFaceBook();

  async function hashData(data) {
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(data.trim().toLowerCase());
    const hashBuffer = await crypto.subtle.digest("SHA-256", dataBuffer);
    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  }

  const NameUpdate = async () => {
    const fullJSON = localStorage.getItem("business-profiles");
    const profile = JSON.parse(fullJSON)[0];
    const trimmedJSON = JSON.stringify({
      name: profile.userName,
    });

    const data = trimmedJSON;
    const name = profile.userName;
    const email = localStorage.getItem("email");

    const hashedName = await hashData(name);
    const hashedEmail = await hashData(email);

    sendFb("Lead", "", { user_data: { fn: hashedName, em: hashedEmail } });

    const utmSource = mixpanel.get_property("utm_source") || "";
    const utmMedium = mixpanel.get_property("utm_medium") || "";
    const utmCampaign = mixpanel.get_property("utm_campaign") || "";
    const utmContent = mixpanel.get_property("utm_content") || "";
    const utmTerm = mixpanel.get_property("utm_term") || "";
    const fbclid = mixpanel.get_property("fbclid") || "";

    try {
      const analyticsData = JSON.parse(
        localStorage.getItem("business-profiles"),
      )[0];
      const cExperience = {
        "Just starting": "just_started",
        "Already selling": "already_selling",
      };
      const cSellingType = {
        Products: "Products",
        Both: "Other",
        // "Digital products": "Digital",
        // "Dropshipping products": "Dropshipping",
        Services: "Services",
      };
      const sellingPlace = analyticsData.sellChannels?.split(", ");
      const cSellingPurchases = {
        "0 - 10": "0-10",
        "10 - 30": "10-30",
        "30 - 100": "30-100",
        "100 - 150": "100-150",
        "150 - 300": "150-300",
        "300 - 500": "300-500",
        "500 - 750": "500-750",
        "750 - 1500": "750-1500",
        "1500 - 3000": "1500-3000",
        "3000 - 5000": "3000-5000",
        "5000 - 10000+": "5000-10000+",
      };
      const cSellingTarget = {
        50: "50",
        150: "150",
        250: "250",
        350: "350",
        "450+": "450+",
      };
      const cSellingGoalDeadline = {
        "In 2-3 months": "2-3 months",
        "In 3-5 months": "3-5 months",
        "In 5-9 months": "5-9 months",
        "In a year": "year",
      };
      const cGoal = {
        "Increase brand recognition": "BrandRecognition",
        "Create winning ad creatives": "WinningAdCreatives",
        "Boost business profitability": "Profitability",
        "Receive more online orders": "MoreOnlineOrders",
        "Launch effective online ads": "EffectiveOnlineAds",
      };
      const predictValue = localStorage.getItem("predict");
      const today = new Date();

      let daysToAdd;
      switch (predictValue) {
        case "option1":
          daysToAdd = 75;
          break;
        case "option2":
          daysToAdd = 120;
          break;
        case "option3":
          daysToAdd = 210;
          break;
        case "option4":
          daysToAdd = 300;
          break;
        default:
          daysToAdd = 0;
      }
      const endDate = new Date();
      endDate.setDate(today.getDate() + daysToAdd);

      const industry = localStorage.getItem("industry");

      const getDeviceType = () => {
        const ua = navigator.userAgent.toLowerCase();

        if (/mobile|iphone|ipod|android.*mobile|windows phone/.test(ua))
          return "mobile";
        if (/tablet|ipad|android(?!.*mobile)/.test(ua)) return "tablet";
        return "desktop";
      };

      const device_type = getDeviceType();

      const getBrowserName = () => {
        const ua = navigator.userAgent;

        if (ua.includes("Edg")) return "Edge";
        if (ua.includes("OPR") || ua.includes("Opera")) return "Opera";
        if (
          ua.includes("Chrome") &&
          !ua.includes("Edg") &&
          !ua.includes("OPR") &&
          !ua.includes("CriOS")
        )
          return "Chrome";
        if (ua.includes("CriOS")) return "Chrome";
        if (
          ua.includes("Safari") &&
          !ua.includes("Chrome") &&
          !ua.includes("CriOS")
        )
          return "Safari";
        if (ua.includes("Firefox")) return "Firefox";

        return "Unknown";
      };

      const browser = getBrowserName();

      const requestData = {
        selling_type: [cSellingType[analyticsData.productsType]],
        selling_target: analyticsData.ordersGoal,
        selling_goal_deadline:
          cSellingGoalDeadline[analyticsData.ordersGoalPeriod],
        name:
          analyticsData.userName?.charAt(0).toUpperCase() +
          analyticsData.userName?.slice(1),
        email: localStorage.getItem("email"),
        source: "web",
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        utm_content: utmContent,
        utm_term: utmTerm,
        fbclid: fbclid,
        prediction: `none`,
        industry: industry
          ? industry.charAt(0).toUpperCase() + industry.slice(1)
          : "none",
        plan: localStorage.getItem("subscriptionsStatus") || "free",
        language: navigator.language || navigator.userLanguage,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        app_version: "none",
        device_id: "none",
        device_type: device_type,
        browser: browser,
        registered_at: Date.now(),
        funnel: process.env.REACT_APP_FUNNEL,
        user_id: localStorage.getItem("userId") || "",
      };

      axios
        .patch(
          "https://staging.zeely.link/statistics/users/customerio",
          requestData,
          {
            headers: {
              "Content-Type": "application/json",
            },
            redirect: "follow",
          },
        )
        .then((response) => {
          console.log("requestData", requestData);
        });
    } catch (sendAnalyticsError) {
      console.error(sendAnalyticsError);
    }
    if (localStorage.getItem("accessToken")) {
      axios
        .patch("https://staging.zeely.link/users", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          redirect: "follow",
        })
        .then((response) => {
          // localStorage.setItem('business-profiles-id', response.data.data.id);
        })
        .catch((error) => {
          sendAlert(
            "https://staging.zeely.link/users",
            data,
            error.response.data.message,
          );
          console.log();
        });
    }
  };

  const sendAlert = async (path, data, errorLog) => {
    const now = new Date();
    const utcString = now.toISOString();

    const formdata = new FormData();
    formdata.append("domain", window.location.hostname);
    formdata.append("time", utcString);
    formdata.append("email", localStorage.getItem("email"));
    formdata.append("path", path);
    formdata.append("data", data);
    formdata.append("error", errorLog);
    console.log(formdata);
    try {
      const response = await axios.post(
        "https://zee.sale/send-alert.php",
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      console.log(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleForget = () => {
    // setTimeLeft(30);
    // forgetPassword();
    setButtonStatus("EnterEmail");
  };

  const handleForget22 = () => {
    setTimeLeft(30);
    forgetPassword();
    setButtonStatus("EnterCode");
  };

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => clearTimeout(timerId);
    }
  }, [timeLeft]);

  useEffect(() => {
    const setVHVariable = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    setVHVariable();
    window.addEventListener("resize", setVHVariable);
    return () => window.removeEventListener("resize", setVHVariable);
  }, []);

  return (
    <>
      {isHomePage ? (
        <Router basename={process.env.REACT_APP_BASENAME}>
          <Landing
            setIsHomePage={setIsHomePage}
            sessionId={sessionId}
            setButtonShow={setButtonShow}
            setHandShow={setHandShow}
            setBlockPaddingBottom={setBlockPaddingBottom}
            sethomeShow={sethomeShow}
            setButtonStatus={setButtonStatus}
          />
        </Router>
      ) : (
        <Router basename={process.env.REACT_APP_BASENAME}>
          <Route
            render={({ history }) => (
              <Wizard
                history={history}
                render={({ step, steps }) => (
                  <div
                    className={`wrapper ${aiShow ? "block-ai" : ""} ${
                      homeShow ? "block-home" : ""
                    } ${whiteWrapper ? "block-white" : ""} ${
                      WelcomeWrapper ? "block-welcome" : ""
                    } ${blockClassName}`}
                  >
                    <Helmet>
                      <meta name="theme-color" content="#000"></meta>
                    </Helmet>
                    <>
                      <WithWizard
                        render={({ next, previous, step, steps }) => (
                          <>
                            <BackHistory
                              setIsHomePage={setIsHomePage}
                              sessionId={sessionId}
                              step={step}
                              nextFunction={next}
                              steps={steps}
                            />
                            <VideoToBlob steps={steps} step={step} />
                          </>
                        )}
                      />
                      {!homeShow &&
                        !aiShow &&
                        steps.indexOf(step) <=
                          steps.findIndex((step) => step.id === "signup2") && (
                          <div className="header">
                            {steps.indexOf(step) >=
                              steps.findIndex(
                                (step) => step.id === "booster",
                              ) && (
                              <div className="header-top">
                                {steps.indexOf(step) >
                                steps.findIndex(
                                  (step) => step.id === "thankyou",
                                ) ? (
                                  <Logo />
                                ) : (
                                  <Logo />
                                )}
                              </div>
                            )}

                            {steps.indexOf(step) <
                              steps.findIndex(
                                (step) => step.id === "booster",
                              ) && (
                              <div className="header-top">
                                {backButton && (
                                  <div
                                    className="back"
                                    onClick={() => {
                                      dispatch(setButtonBackClick(true));
                                    }}
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M11 2L5 8L11 14"
                                        stroke={"black"}
                                        strokeWidth="2.1"
                                        strokeLinecap="round"
                                      />
                                    </svg>
                                  </div>
                                )}
                                {steps.indexOf(step) <
                                  steps.findIndex(
                                    (step) => step.id === "booster",
                                  ) &&
                                  steps.findIndex(
                                    (step) => step.id === "signup",
                                  ) != steps.indexOf(step) &&
                                  steps.findIndex(
                                    (step) => step.id === "confirm-email",
                                  ) != steps.indexOf(step) &&
                                  steps.findIndex(
                                    (step) => step.id === "password",
                                  ) != steps.indexOf(step) &&
                                  steps.findIndex(
                                    (step) => step.id === "loading",
                                  ) != steps.indexOf(step) &&
                                  steps.findIndex(
                                    (step) => step.id === "name",
                                  ) != steps.indexOf(step) &&
                                  steps.findIndex(
                                    (step) => step.id === "ai-loader1",
                                  ) != steps.indexOf(step) &&
                                  steps.findIndex((step) => step.id === "") !=
                                    steps.indexOf(step) &&
                                  steps.findIndex(
                                    (step) => step.id === "sellingstage",
                                  ) != steps.indexOf(step) && (
                                    <>
                                      <WithWizard
                                        render={({
                                          next,
                                          previous,
                                          step,
                                          steps,
                                        }) => (
                                          <div
                                            className="back"
                                            onClick={() => {
                                              if (buttonStatus === "Summary") {
                                                setButtonStatus("");
                                                history.push("/summary");
                                              } else {
                                                if (
                                                  steps.indexOf(step) ===
                                                  steps.findIndex(
                                                    (step) =>
                                                      step.id === "trial",
                                                  )
                                                ) {
                                                  window.history.back();
                                                } else {
                                                  history.push({
                                                    pathname: previousPage,
                                                    search: `?${queryParams.toString()}`,
                                                  });
                                                }
                                              }
                                            }}
                                          >
                                            {blockClassName ===
                                            "block-price9" ? (
                                              <svg
                                                width="30"
                                                height="30"
                                                viewBox="0 0 30 30"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M9 9L21 21"
                                                  stroke="white"
                                                  stroke-width="1.6"
                                                  stroke-linecap="round"
                                                />
                                                <path
                                                  d="M21 9L9 21"
                                                  stroke="white"
                                                  stroke-width="1.6"
                                                  stroke-linecap="round"
                                                />
                                              </svg>
                                            ) : (
                                              <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M11 2L5 8L11 14"
                                                  stroke={
                                                    whiteWrapper
                                                      ? "black"
                                                      : "black"
                                                  }
                                                  strokeWidth="2.1"
                                                  strokeLinecap="round"
                                                />
                                              </svg>
                                            )}
                                          </div>
                                        )}
                                      />
                                    </>
                                  )}

                                {whiteWrapper ? (
                                  steps.indexOf(step) !=
                                    steps.findIndex(
                                      (step) => step.id === "price",
                                    ) &&
                                  steps.indexOf(step) !=
                                    steps.findIndex(
                                      (step) => step.id === "trial",
                                    ) ? (
                                    <LogoDark />
                                  ) : blockClassName === "block-price9" ? (
                                    <Logo />
                                  ) : (
                                    <LogoGrowth
                                      style={{
                                        width: "151rem",
                                        height: "32rem",
                                      }}
                                    />
                                  )
                                ) : (
                                  <Logo />
                                )}
                                {}
                              </div>
                            )}
                            {steps.indexOf(step) <
                              steps.findIndex((step) => step.id === "loader") &&
                              !whiteWrapper && (
                                <div className="line">
                                  <div className="line-item">
                                    <i
                                      style={{
                                        width: `100%`,
                                      }}
                                    ></i>
                                  </div>

                                  {indexStepPage === 1 ? (
                                    <div className="line-item">
                                      <i
                                        style={{
                                          width: `50%`,
                                        }}
                                      ></i>
                                    </div>
                                  ) : indexStepPage > 1 ? (
                                    <div className="line-item">
                                      <i
                                        style={{
                                          width: `100%`,
                                        }}
                                      ></i>
                                    </div>
                                  ) : (
                                    <div className="line-item"></div>
                                  )}
                                  {indexStepPage === 2 ? (
                                    <div className="line-item">
                                      <i
                                        style={{
                                          width: `50%`,
                                        }}
                                      ></i>
                                    </div>
                                  ) : indexStepPage > 2 ? (
                                    <div className="line-item">
                                      <i
                                        style={{
                                          width: `100%`,
                                        }}
                                      ></i>
                                    </div>
                                  ) : (
                                    <div className="line-item"></div>
                                  )}

                                  {/* <Line
                                  percent={(steps.indexOf(step) + 0) / steps.findIndex(step => step.id === "platform") * 100}
                                  className="pad-b"
                              /> */}

                                  {/* {steps.indexOf(step) >
                                  steps.findIndex(
                                    (step) => step.id === "goals"
                                  ) ? (
                                    <div className="line-item">
                                      <i
                                        style={{
                                          width: `${
                                            ((steps.indexOf(step) -
                                              steps.findIndex(
                                                (step) => step.id === "goals"
                                              )) /
                                              (steps.findIndex(
                                                (step) => step.id === "signup"
                                              ) -
                                                steps.findIndex(
                                                  (step) => step.id === "goals"
                                                ))) *
                                            100
                                          }%`,
                                        }}
                                      ></i>
                                    </div>
                                  ) : (
                                    <div className="line-item"></div>
                                  )} */}
                                </div>
                              )}
                          </div>
                        )}
                    </>

                    <div
                      className="block"
                      style={{ paddingBottom: blockPaddingBottom, overflow }}
                    >
                      {" "}
                      <AnimateHeight
                        className="block-animate"
                        duration={600}
                        height={blockHeight}
                      >
                        <div className="block-height" ref={blockHeightRef}>
                          {steps.indexOf(step) >
                            steps.findIndex(
                              (step) => step.id === "prediction",
                            ) && (
                            <>
                              {(steps.indexOf(step) ===
                                steps.findIndex(
                                  (step) => step.id === "price",
                                ) ||
                                steps.indexOf(step) ===
                                  steps.findIndex(
                                    (step) => step.id === "trial",
                                  )) && (
                                <>
                                  <div
                                    className={`${
                                      steps.indexOf(step) ===
                                        steps.findIndex(
                                          (step) => step.id === "price",
                                        ) && "preload"
                                    }`}
                                  >
                                    {TrialElement}
                                  </div>

                                  {/* {steps.indexOf(step) ===
                                    steps.findIndex(
                                      (step) => step.id === "price"
                                    ) && } */}
                                </>
                              )}
                            </>
                          )}

                          <Steps>
                            {stepsMain.map((stepMain) => (
                              <Step key={stepMain.id} id={stepMain.id}>
                                <>
                                  <div className="preload">
                                    {stepMain.preload}

                                    {steps.indexOf(step) >
                                      steps.findIndex(
                                        (step) => step.id === "acquisition",
                                      ) &&
                                      steps.indexOf(step) <
                                        steps.findIndex(
                                          (step) => step.id === "avatars",
                                        ) && (
                                        <>
                                          <img
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                            }}
                                            src={
                                              process.env.REACT_APP_BASENAME +
                                              "/img/scene_avatars 2 1.webp"
                                            }
                                            alt=""
                                          />

                                          <ReactPlayer
                                            width="100%"
                                            height="auto"
                                            loop={true}
                                            playing={true}
                                            playsinline={true}
                                            volume={0.5}
                                            muted={true}
                                            url={
                                              process.env.REACT_APP_BASENAME +
                                              `/video/scene_avatars.m3u8`
                                            }
                                            controls={false}
                                          />
                                        </>
                                      )}

                                    {steps.indexOf(step) >
                                      steps.findIndex(
                                        (step) => step.id === "website",
                                      ) &&
                                      steps.indexOf(step) <
                                        steps.findIndex(
                                          (step) => step.id === "demosite",
                                        ) &&
                                      !WebsiteStatus && (
                                        <>
                                          <img
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                            }}
                                            src={
                                              process.env.REACT_APP_BASENAME +
                                              "/img/shop flow mockup cover_compressed.webp"
                                            }
                                            alt=""
                                          />

                                          <ReactPlayer
                                            width="100%"
                                            height="auto"
                                            loop={true}
                                            playing={true}
                                            playsinline={true}
                                            volume={0.5}
                                            muted={true}
                                            url={
                                              process.env.REACT_APP_BASENAME +
                                              `/video/show_flow_mockup_compressed.m3u8`
                                            }
                                            controls={false}
                                          />
                                        </>
                                      )}

                                    {steps.indexOf(step) >
                                      steps.findIndex(
                                        (step) => step.id === "website",
                                      ) &&
                                      steps.indexOf(step) <
                                        steps.findIndex(
                                          (step) => step.id === "demosite",
                                        ) &&
                                      WebsiteStatus && (
                                        <>
                                          <img
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                            }}
                                            src={
                                              process.env.REACT_APP_BASENAME +
                                              "/img/Shopify shop flow mockup cover_compressed.webp"
                                            }
                                            alt=""
                                          />

                                          <ReactPlayer
                                            width="100%"
                                            height="auto"
                                            loop={true}
                                            playing={true}
                                            playsinline={true}
                                            volume={0.5}
                                            muted={true}
                                            url={
                                              process.env.REACT_APP_BASENAME +
                                              `/video/shopify_shop_flow_mockup_compressed.m3u8`
                                            }
                                            controls={false}
                                          />
                                        </>
                                      )}
                                    {steps.indexOf(step) >
                                      steps.findIndex(
                                        (step) => step.id === "demovideos",
                                      ) &&
                                      steps.indexOf(step) <
                                        steps.findIndex(
                                          (step) => step.id === "demoanalytics",
                                        ) && (
                                        <>
                                          <img
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                            }}
                                            src={
                                              process.env.REACT_APP_BASENAME +
                                              "/img/analytic flow mockup cover_compressed.webp"
                                            }
                                            alt=""
                                          />

                                          <ReactPlayer
                                            width="100%"
                                            height="auto"
                                            loop={true}
                                            playing={true}
                                            playsinline={true}
                                            volume={0.5}
                                            muted={true}
                                            url={
                                              process.env.REACT_APP_BASENAME +
                                              `/video/analytic_flow_mockup_compressed.m3u8`
                                            }
                                            controls={false}
                                          />
                                        </>
                                      )}

                                    {steps.indexOf(step) >
                                      steps.findIndex(
                                        (step) => step.id === "demoanalytics",
                                      ) &&
                                      steps.indexOf(step) <
                                        steps.findIndex(
                                          (step) => step.id === "demoads",
                                        ) && (
                                        <>
                                          <img
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                            }}
                                            src={
                                              process.env.REACT_APP_BASENAME +
                                              "/img/promotion flow mockup cover_compressed.webp"
                                            }
                                            alt=""
                                          />

                                          <ReactPlayer
                                            width="100%"
                                            height="auto"
                                            loop={true}
                                            playing={true}
                                            playsinline={true}
                                            volume={0.5}
                                            muted={true}
                                            url={
                                              process.env.REACT_APP_BASENAME +
                                              `/video/promotion_flow_mockup__compressed.m3u8`
                                            }
                                            controls={false}
                                          />
                                        </>
                                      )}

                                    {steps.indexOf(step) >
                                      steps.findIndex(
                                        (step) => step.id === "avatars",
                                      ) &&
                                      steps.indexOf(step) <
                                        steps.findIndex(
                                          (step) =>
                                            step.id === "video_creation",
                                        ) && (
                                        <>
                                          <img
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                            }}
                                            src={
                                              process.env.REACT_APP_BASENAME +
                                              "/img/scene_video builder.webp"
                                            }
                                            alt=""
                                          />

                                          <ReactPlayer
                                            width="100%"
                                            height="auto"
                                            loop={true}
                                            playing={true}
                                            playsinline={true}
                                            volume={0.5}
                                            muted={true}
                                            url={
                                              process.env.REACT_APP_BASENAME +
                                              `/video/scene_video_builder_compressed-1.m3u8`
                                            }
                                            controls={false}
                                          />
                                        </>
                                      )}
                                  </div>

                                  {!(
                                    welcometoShow ||
                                    steps.indexOf(step) ===
                                      steps.findIndex(
                                        (step) => step.id === "trial",
                                      )
                                  ) && (
                                    <Reveal
                                      style={{
                                        ...blockStyle,
                                        display: showBlock ? "block" : "none",
                                      }}
                                      cascade
                                      keyframes={customAnimation}
                                    >
                                      {stepMain.component}
                                    </Reveal>
                                  )}
                                  {showTerm && (
                                    <>
                                      <div
                                        className="term-back"
                                        onClick={termClose}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="46"
                                          height="46"
                                          viewBox="0 0 46 46"
                                          fill="none"
                                        >
                                          <path
                                            d="M25.75 17L20.25 22.8182L25.75 29"
                                            stroke="black"
                                            stroke-width="1.6"
                                            stroke-linecap="round"
                                          />
                                        </svg>
                                      </div>
                                      <Term></Term>
                                    </>
                                  )}
                                  {showPrivacy && (
                                    <>
                                      <div
                                        className="term-back"
                                        onClick={termClose}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="46"
                                          height="46"
                                          viewBox="0 0 46 46"
                                          fill="none"
                                        >
                                          <path
                                            d="M25.75 17L20.25 22.8182L25.75 29"
                                            stroke="black"
                                            stroke-width="1.6"
                                            stroke-linecap="round"
                                          />
                                        </svg>
                                      </div>
                                      <Privacy></Privacy>
                                    </>
                                  )}
                                </>
                              </Step>
                            ))}
                          </Steps>
                        </div>
                      </AnimateHeight>
                      {welcometoShow && (
                        <Steps>
                          {stepsMain.map((stepMain) => (
                            <Step key={stepMain.id} id={stepMain.id}>
                              <div className="preload">{stepMain.preload}</div>
                              {stepMain.component}
                            </Step>
                          ))}
                        </Steps>
                      )}
                      {buttonShow && (
                        <div className="block-button">
                          <WithWizard
                            render={({ next, previous, step, steps }) => (
                              <>
                                {buttonSkip && (
                                  <div
                                    className="skip"
                                    onClick={() => handleClickSkip()}
                                  >
                                    Skip for now
                                  </div>
                                )}
                                <MyButton
                                  // ref={nextPageButtonRef}
                                  buttonStatus={buttonStatus}
                                  buttonTime={buttonTime}
                                  buttonText={buttonText}
                                  onClick={() => handleClick(next)}
                                  className={
                                    areAllCheckboxesUnchecked() ||
                                    areAllRadioUnchecked()
                                      ? error
                                        ? "error"
                                        : "disable"
                                      : undefined
                                  }
                                ></MyButton>
                                {handShow && (
                                  <div className="hand">
                                    <svg
                                      width="55"
                                      height="55"
                                      viewBox="0 0 55 55"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_11035_53290)">
                                        <path
                                          d="M15.323 14.04C13.5422 15.0681 12.9223 17.3819 13.9504 19.1626L21.3335 31.9506L20.1934 31.6158L19.7859 31.535C18.8377 31.2832 17.8283 31.4172 16.9787 31.9077C16.129 32.3983 15.5083 33.2054 15.2522 34.1525C15.0004 35.1007 15.1345 36.11 15.625 36.9597C16.1155 37.8093 16.9227 38.4301 17.8697 38.6861L17.8891 38.7197L31.8116 42.3642L31.8981 42.359L31.9711 42.4078C34.2106 42.6893 36.4809 42.2333 38.4381 41.109L40.3 40.034C41.4661 39.3641 42.4883 38.4704 43.3081 37.4043C44.1278 36.3382 44.7289 35.1207 45.0769 33.8217C45.4249 32.5227 45.5129 31.1678 45.3358 29.8347C45.1588 28.5016 44.7202 27.2165 44.0452 26.0534L39.1627 17.5967C38.1346 15.8159 35.8198 15.1966 34.0401 16.2241C33.579 16.4903 33.2256 16.8632 32.9297 17.2707C31.7621 16.0685 29.8684 15.7459 28.3583 16.6177C27.529 17.0965 26.9555 17.8606 26.6813 18.7132C25.7774 18.5142 24.8317 18.6584 24.0281 19.1177C23.6609 19.3359 23.3344 19.6163 23.0631 19.9463L20.4456 15.4126C19.4175 13.6319 17.1038 13.0119 15.323 14.04Z"
                                          fill="white"
                                        ></path>
                                        <path
                                          d="M15.323 14.04C13.5422 15.0681 12.9223 17.3819 13.9504 19.1626L21.3335 31.9506L20.1934 31.6158L19.7859 31.535C18.8377 31.2832 17.8283 31.4172 16.9787 31.9077C16.129 32.3983 15.5083 33.2054 15.2522 34.1525C15.0004 35.1007 15.1345 36.11 15.625 36.9597C16.1155 37.8093 16.9227 38.4301 17.8697 38.6861L17.8891 38.7197L31.8116 42.3642L31.8981 42.359L31.9711 42.4078C34.2106 42.6893 36.4809 42.2333 38.4381 41.109L40.3 40.034C41.4661 39.3641 42.4883 38.4704 43.3081 37.4043C44.1278 36.3382 44.7289 35.1207 45.0769 33.8217C45.4249 32.5227 45.5129 31.1678 45.3358 29.8347C45.1588 28.5016 44.7202 27.2165 44.0452 26.0534L39.1627 17.5967C38.1346 15.8159 35.8198 15.1966 34.0401 16.2241C33.579 16.4903 33.2256 16.8632 32.9297 17.2707C31.7621 16.0685 29.8684 15.7459 28.3583 16.6177C27.529 17.0965 26.9555 17.8606 26.6813 18.7132C25.7774 18.5142 24.8317 18.6584 24.0281 19.1177C23.6609 19.3359 23.3344 19.6163 23.0631 19.9463L20.4456 15.4126C19.4175 13.6319 17.1038 13.0119 15.323 14.04ZM16.573 16.2051C17.1738 15.8582 17.9337 16.0618 18.2805 16.6626L25.1555 28.5705L27.3206 27.3205L24.8206 22.9903C24.4737 22.3895 24.6773 21.6297 25.2781 21.2828C25.8789 20.9359 26.6388 21.1395 26.9857 21.7403L29.4857 26.0705L31.6507 24.8205L29.1507 20.4903C28.8038 19.8895 29.0074 19.1297 29.6083 18.7828C30.2091 18.4359 30.9689 18.6395 31.3158 19.2403L33.8158 23.5705L36.0826 22.2617L34.8326 20.0967C34.4857 19.4958 34.6893 18.736 35.2901 18.3891C35.8899 18.0429 36.6508 18.2458 36.9977 18.8467L41.8808 27.3045C44.0458 31.0544 42.7999 35.704 39.049 37.8696L37.1892 38.9433C35.6033 39.859 33.9059 40.0841 32.2744 39.8857L18.5124 36.2842C17.7525 36.0806 17.4494 35.5556 17.653 34.7957C17.8577 34.0353 18.3817 33.7328 19.1415 33.9364L26.5061 35.9097L16.1155 17.9126C15.7686 17.3118 15.9722 16.552 16.573 16.2051Z"
                                          fill="black"
                                        ></path>
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_11035_53290">
                                          <rect
                                            width="40"
                                            height="40"
                                            fill="white"
                                            transform="translate(0 20) rotate(-30)"
                                          ></rect>
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                )}

                                {signupBottom == "checkbox" && (
                                  <Reveal cascade keyframes={customAnimation}>
                                    <div className="googlesingup-bottom">
                                      {window.location.pathname ===
                                      process.env.REACT_APP_BASENAME +
                                        "/signup" ? (
                                        <>
                                          {loginChangeStatus && (
                                            <div className="googlesingup-bottom-login">
                                              Already have an account?{" "}
                                              <Link
                                                onClick={loginChange}
                                                style={{
                                                  cursor: "pointer",
                                                  textDecoration: "underline",
                                                  textDecorationColor: "#000",
                                                }}
                                              >
                                                Log in
                                              </Link>
                                            </div>
                                          )}
                                          <div className="googlesingup-bottom-term">
                                            By continuing I agree to the
                                            <br />{" "}
                                            <span onClick={termChange}>
                                              Terms & Conditions
                                            </span>
                                            ,{" "}
                                            <span onClick={privacyChange}>
                                              Privacy Policy
                                            </span>
                                          </div>
                                        </>
                                      ) : (
                                        <div className="googlesingup-bottom-login">
                                          <Link
                                            onClick={() => {
                                              history.push("/signup");
                                              const urlParams =
                                                new URLSearchParams(
                                                  window.location.search,
                                                );
                                              mixpanel.track(
                                                "web_signup_2_act",
                                                {
                                                  session_id: sessionId,
                                                  web_utm_campaign:
                                                    urlParams.get(
                                                      "utm_campaign",
                                                    ),
                                                  web_utm_source:
                                                    urlParams.get("utm_source"),
                                                  web_utm_medium:
                                                    urlParams.get("utm_medium"),
                                                  web_utm_content:
                                                    urlParams.get(
                                                      "utm_content",
                                                    ),
                                                  web_utm_term:
                                                    urlParams.get("utm_term"),
                                                  isDebug: false,
                                                  funnel:
                                                    process.env
                                                      .REACT_APP_FUNNEL,
                                                },
                                              );
                                            }}
                                            style={{
                                              cursor: "pointer",
                                              textDecoration: "none",
                                            }}
                                          >
                                            Sign up with a new email
                                          </Link>
                                        </div>
                                      )}
                                    </div>
                                    {/* <div className="signup-bottom">
                                              <div className="signup-bottom-checkbox">
                                                  <label>
                                                      <CustomCheckbox
                                                          style={{ marginRight: '10rem' }}
                                                          checked={isChecked}
                                                          onChange={handleChange}
                                                      >

                                                      </CustomCheckbox>
                                                      <p>By clicking on sign-up, you agree to Zeely's <span onClick={termChange}>Terms and Conditions</span> and <span onClick={privacyChange}>Privacy Policy.</span></p>

                                                  </label>
                                              </div>
                                              <div class="block-bottom">
                                                  By continuing I agree to the<br />
                                                  <span onClick={termChange}>Terms & Conditions</span>, <span onClick={privacyChange}>Privacy Policy.</span>

                                                  {/* <div className="signup-bottom-text">
                                                      Zeely, Inc. 2810 N Church St, Ste 27833,
                                                      Wilmington, DE 19802-4447
                                                  </div> */}
                                    {/* </div> */}
                                    {/* </div> */}
                                  </Reveal>
                                )}
                                {signupBottom == "forget" && (
                                  <Reveal cascade keyframes={customAnimation}>
                                    <div
                                      className="forget"
                                      onClick={handleForget}
                                    >
                                      Forgot password?
                                    </div>
                                  </Reveal>
                                )}
                                {signupBottom == "loginChange" && (
                                  <Reveal cascade keyframes={customAnimation}>
                                    <div
                                      className="forget"
                                      onClick={handleForget}
                                    >
                                      Forgot password?
                                    </div>
                                  </Reveal>
                                )}
                                {signupBottom == "EnterCode" && (
                                  <Reveal cascade keyframes={customAnimation}>
                                    {timeLeft > 0 ? (
                                      <div className="forget">
                                        Wait 00:{timeLeft} to resend
                                      </div>
                                    ) : (
                                      <div
                                        className="forget"
                                        onClick={handleForget}
                                      >
                                        I didn't receive a code
                                      </div>
                                    )}
                                  </Reveal>
                                )}
                              </>
                            )}
                          />
                        </div>
                      )}
                      {buttonChoose && (
                        <div className="block-button">
                          <WithWizard
                            render={({ next, previous, step, steps }) => (
                              <>
                                <div className="choose-action">
                                  <div
                                    className="choose-action-btn"
                                    onClick={(event) =>
                                      handleClickChoose(
                                        next,
                                        event.currentTarget,
                                        creativeId,
                                        false,
                                      )
                                    }
                                  >
                                    <svg
                                      width="21"
                                      height="20"
                                      viewBox="0 0 21 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5.24485 4.49493C5.5238 4.21598 5.97606 4.21598 6.25501 4.49493L10.7499 8.98929L15.2449 4.49493C15.5023 4.23744 15.9075 4.21763 16.1877 4.43551L16.255 4.49493C16.534 4.77388 16.534 5.22614 16.255 5.50508L11.7606 10L16.255 14.4949C16.5125 14.7524 16.5323 15.1576 16.3144 15.4378L16.255 15.5051C15.9761 15.784 15.5238 15.784 15.2449 15.5051L10.7499 11.0107L6.25501 15.5051C5.99752 15.7626 5.59235 15.7824 5.31215 15.5645L5.24485 15.5051C4.96591 15.2261 4.96591 14.7739 5.24485 14.4949L9.73922 10L5.24485 5.50508C4.98737 5.24759 4.96756 4.84243 5.18543 4.56222L5.24485 4.49493Z"
                                        fill="#EF2C4F"
                                        stroke="#EF2C4F"
                                        stroke-width="0.4"
                                      />
                                    </svg>
                                    No
                                  </div>
                                  <div
                                    className="choose-action-btn"
                                    onClick={(event) =>
                                      handleClickChoose(
                                        next,
                                        event.currentTarget,
                                        creativeId,
                                        true,
                                      )
                                    }
                                  >
                                    <svg
                                      width="21"
                                      height="20"
                                      viewBox="0 0 21 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.60693 13.2756L4.8263 9.49492C4.54735 9.21598 4.09509 9.21598 3.81614 9.49492C3.5372 9.77387 3.5372 10.2261 3.81614 10.5051L8.10186 14.7908C8.3808 15.0697 8.83306 15.0697 9.11201 14.7908L17.6834 6.21936C17.9624 5.94042 17.9624 5.48816 17.6834 5.20921C17.4045 4.93026 16.9522 4.93026 16.6733 5.20921L8.60693 13.2756Z"
                                        fill="#5BF0A5"
                                        stroke="#5BF0A5"
                                        stroke-width="0.444444"
                                      />
                                    </svg>
                                    Yes
                                  </div>
                                </div>
                              </>
                            )}
                          />
                        </div>
                      )}
                    </div>

                    {showWebSite && (
                      <div className="brandname">
                        <div className="brandname-wrapper">
                          <Website BusinessAreaHave={BusinessAreaHave} />
                        </div>
                      </div>
                    )}

                    {showTermBundle && (
                      <div className="brandname">
                        <div className="brandname-wrapper">
                          <div className="term-back" onClick={termBundleClose}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="46"
                              height="46"
                              viewBox="0 0 46 46"
                              fill="none"
                            >
                              <path
                                d="M25.75 17L20.25 22.8182L25.75 29"
                                stroke="black"
                                stroke-width="1.6"
                                stroke-linecap="round"
                              />
                            </svg>
                          </div>
                          <Term />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              />
            )}
          />
        </Router>
      )}
    </>
  );
}

export default App;
